import React, { FC, memo, useEffect, useState } from 'react'

import { useSetFocus } from '@please/lrud'

import { Button } from '@/components/Button/Button'
import { LoadableComponent } from '@/components/LoadableComponent/LoadableComponent'
import { focusIds } from '@/constants/focus'
import { icons } from '@/constants/icons'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import useConfirmationStore from '@/store/useConfirmationStore'

import {
  Actions,
  ActionsWrapper,
  Description,
  PopUpBox,
  PopUpElem,
  Title,
} from './styles'

const ConfirmationPopupRaw: FC = () => {
  const { popup, onSubmit, onCancel } = useConfirmationStore()
  const setFocus = useSetFocus()
  const { t } = useCommonTranslation()

  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    popup && setTimeout(setFocus, 0, focusIds.POPUP)
  }, [popup])

  if (!popup) {
    return null
  }

  const okHandler = async () => {
    setIsLoading(true)
    try {
      await onSubmit()
      setFocus(popup.prevFocusId)
    } finally {
      setIsLoading(false)
    }
  }
  const cancelHandler = () => {
    onCancel()
    setFocus(popup.prevFocusId)
  }

  return (
    <PopUpBox focusId={focusIds.POPUP} isTrap={true}>
      <PopUpElem>
        {popup.title && <Title>{popup.title}</Title>}
        {popup.description && <Description>{popup.description}</Description>}

        <ActionsWrapper>
          <LoadableComponent isLoading={isLoading}>
            <Actions>
              <Button
                iconSrc={icons.navigation.exit}
                text={t('cancel')}
                onClick={cancelHandler}
              />
              <Button
                iconSrc={icons.navigation.check}
                text={popup.submitLabel ?? t('ok')}
                onClick={okHandler}
              />
            </Actions>
          </LoadableComponent>
        </ActionsWrapper>
      </PopUpElem>
    </PopUpBox>
  )
}

export const ConfirmationPopup = memo(ConfirmationPopupRaw)
